module.exports = __webpack_public_path__ + "static/img/topbg.af6dc65e.webp";